var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTutionApps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2168_115)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "add-path",
    opacity: 0.987,
    d: "M2.82434 10.2193C3.70223 7.11965 5.61622 5.18063 8.67088 4.2808C15.7007 4.25149 22.7304 4.28184 29.7597 4.37185C31.3399 4.80541 32.5765 5.50854 33.5195 6.45152C34.463 7.39502 35.1664 8.6325 35.5999 10.2139C35.7194 17.2439 35.7194 24.2738 35.5999 31.3038C35.1664 32.8852 34.463 34.1227 33.5195 35.0662C32.576 36.0097 31.3385 36.7131 29.7572 37.1466C22.7271 37.2662 15.6973 37.2662 8.66722 37.1466C7.0858 36.7131 5.84832 36.0097 4.90481 35.0662C3.96132 34.1227 3.25794 32.8853 2.82443 31.3039C2.70501 24.2756 2.70498 17.2476 2.82434 10.2193Z",
    stroke: "#999999",
    strokeWidth: 2.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "add-path",
    opacity: 0.987,
    d: "M43.3595 10.2193C44.2374 7.11965 46.1514 5.18063 49.206 4.2808C56.2359 4.25149 63.2656 4.28184 70.2949 4.37185C71.8751 4.80541 73.1117 5.50854 74.0547 6.45152C74.9982 7.39502 75.7016 8.6325 76.1351 10.2139C76.2546 17.2439 76.2546 24.2738 76.1351 31.3038C75.7016 32.8852 74.9982 34.1227 74.0547 35.0662C73.1112 36.0097 71.8737 36.7131 70.2923 37.1466C63.2623 37.2662 56.2324 37.2662 49.2024 37.1466C47.621 36.7131 46.3835 36.0097 45.44 35.0662C44.4965 34.1227 43.7931 32.8853 43.3596 31.3039C43.2402 24.2756 43.2401 17.2476 43.3595 10.2193Z",
    stroke: "#999999",
    strokeWidth: 2.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "add-path",
    opacity: 0.987,
    d: "M2.3595 52.2193C3.23739 49.1197 5.15138 47.1806 8.20603 46.2808C15.2359 46.2515 22.2656 46.2818 29.2949 46.3718C30.8751 46.8054 32.1117 47.5085 33.0547 48.4515C33.9982 49.395 34.7016 50.6325 35.1351 52.2139C35.2546 59.2439 35.2546 66.2738 35.1351 73.3038C34.7016 74.8852 33.9982 76.1227 33.0547 77.0662C32.1112 78.0097 30.8737 78.7131 29.2923 79.1466C22.2623 79.2662 15.2324 79.2662 8.20238 79.1466C6.62096 78.7131 5.38347 78.0097 4.43997 77.0662C3.49647 76.1227 2.79309 74.8853 2.35959 73.3039C2.24017 66.2756 2.24014 59.2476 2.3595 52.2193Z",
    stroke: "#999999",
    strokeWidth: 2.54
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61,
    cy: 62,
    r: 16.73,
    stroke: "#999999",
    strokeWidth: 2.54
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2168_115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutionApps);
export default __webpack_public_path__ + "static/media/tution_apps.3fda57d4f5654f2ce79854444737e6bd.svg";
export { ForwardRef as ReactComponent };